/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Banner_OneInputs */

const en_inbox_banner_one = /** @type {(inputs: Inbox_Banner_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 new recipe suggestion from friends`)
};

const de_inbox_banner_one = /** @type {(inputs: Inbox_Banner_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 neuer Rezeptvorschlag von Freunden`)
};

/**
* | output |
* | --- |
* | "1 new recipe suggestion from friends" |
*
* @param {Inbox_Banner_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const inbox_banner_one = /** @type {((inputs?: Inbox_Banner_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Banner_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_inbox_banner_one(inputs)
	return en_inbox_banner_one(inputs)
});